<div class="content-body default-height">
    <!-- Breadcrumb  -->
    <app-breadcrumb [breadcrumb]="breadcrumbList" [addProperty]="'Back'" (addEvent)="goBackToList($event)"> </app-breadcrumb>
    <div class="container-fluid">
      <app-owner-overview (profileDetailsEvent)="getUserDetails($event)"></app-owner-overview>
  
      <div class="tab-content" id="tabContentMyProfileBottom">
        <div class="card">
            <div class="card-header-line">
             <div class="row" *ngIf="userProperties?.length">
            <div class="col-xl-12 m-3">                
                 <select class="form-control width320" (change)="getPropertyDocuments()" [(ngModel)]="choosenProperty">
                    <option value="" selected disabled>Select Property</option>
                    <option *ngFor="let property of userProperties" [value]="property.uid">
                         {{property.name }} 
                    </option>
                 </select>
            </div>
        </div>
        </div>
         
        <div class="row">
            <div class="col-xl-12">
            <div class="table-responsive active-projects style-1 ItemsCheckboxSec shorting dataTables_wrapper" *ngIf="ownerDocuments?.length">  
                <table matSort (matSortChange)="sortData($event)" id="empoloyees-tbl" class="table mb-0">
                    <thead>
                        <tr>                          
                            <th>Name</th>
                            <th>Document Type</th>
                            <th>Description</th>
                            <th class="text-center">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for(item of ownerDocuments; track item){
                        <tr>                           
                            <td>{{ item.name }}</td>
                            <td>                    
                                <span>{{ item.document_type }}</span>             
                            </td>
                            <td>{{ item.description }}</td>                            
                            <td class="text-center">
                                <button type="button"
                                  class="btn btn-success shadow btn-xs sharp me-1 mb-1" (click)="viewImage(item.document_url)"><i class="fa fa-eye"></i>
                                </button>
                            </td>
                        </tr>
                        }
                    </tbody>
                </table>                
            </div>                
            <p class="text-center mt-2 no-docs" *ngIf="!ownerDocuments?.length">No documents found</p>
        </div>
    </div>
</div>
        </div>
    </div>
</div>

<ng-template #content let-modal>
    <div class="modal-header">
      <h5 class="modal-title">Select Property</h5>
      <button type="button" class="btn-close" (click)="closeModal()"></button>
    </div>
    <div class="modal-body">
        <select class="default-select style-1 form-control">
            <option  data-display="Select" value="" selected>Please select</option>
            <option value="Property1">Property1</option>                          
            <option value="Property2">Property2</option>
        </select>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="closeModal()">Close</button>
      <button type="button" class="btn btn-primary" (click)="closeModal()">Go to Document</button>
    </div>
</ng-template>